import { render, staticRenderFns } from "./MobileFooterLinks.vue?vue&type=template&id=b8b70bb2"
import script from "./MobileFooterLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileFooterLinks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MobileFooterLinks.vue?vue&type=style&index=0&id=b8b70bb2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports